import { Constants, PBRMaterial, ReflectionProbe, RenderTargetTexture, Scene, Vector3 } from "@babylonjs/core"

export class ReflectionHandler
{
    public ReflectionProbes:ReflectionProbe[];
    private _scene:Scene;
    constructor(scene:Scene)
    {
        this._scene = scene;
    }
     public async AddReflectionProbes()
    {
        var reflectionProbe1 = new ReflectionProbe("probe1",1024,this._scene)
        var reflectionProbe2 = new ReflectionProbe("probe2",1024,this._scene)
        var reflectionProbe3 = new ReflectionProbe("probe3",1024,this._scene)

        reflectionProbe1.refreshRate = RenderTargetTexture.REFRESHRATE_RENDER_ONCE
        reflectionProbe2.refreshRate = RenderTargetTexture.REFRESHRATE_RENDER_ONCE
        reflectionProbe3.refreshRate = RenderTargetTexture.REFRESHRATE_RENDER_ONCE

        reflectionProbe1.position = new Vector3(0,4,50)
        reflectionProbe2.position = new Vector3(0,4,-50)
        reflectionProbe3.position = new Vector3(0,8,0)      
        for(let i=0;i<this._scene.meshes.length;i++)
        {
            if(!/GlassFront/i.test(this._scene.meshes[i].name))
            {
                console.log(this._scene.meshes[i].name)
                reflectionProbe1.renderList.push(this._scene.meshes[i])
            }
            if(!/GlassBack/i.test(this._scene.meshes[i].name))
            {
                console.log(this._scene.meshes[i].name)
                reflectionProbe2.renderList.push(this._scene.meshes[i])
            }
            reflectionProbe3.renderList.push(this._scene.meshes[i])        
        }     
        console.log( reflectionProbe1.renderList)
        console.log( reflectionProbe2.renderList)
        console.log( reflectionProbe3.renderList)


        for(let i=0;i<this._scene.materials.length;i++)
        {
            var mat =this._scene.materials[i] as PBRMaterial
            console.log(mat.name)
            if(mat.name=="GlassFront")
            {
                mat.reflectionTexture = reflectionProbe2.cubeTexture;
                mat.realTimeFiltering=true;
                mat.realTimeFilteringQuality= Constants.TEXTURE_FILTERING_QUALITY_HIGH
            }
            if(mat.name=="GlassBack")
            {
                mat.reflectionTexture = reflectionProbe1.cubeTexture;
                mat.realTimeFiltering=true;
                mat.realTimeFilteringQuality= Constants.TEXTURE_FILTERING_QUALITY_HIGH
            }
        }
    }
}